import './App.css';
import TaskComponent from './components/TaskComponent/TaskComponent';
import TodoPage from './pages/TodoPage/TodoPage';

function App() {
  return (

    <div className="App">
      <TodoPage />

    </div>
  );
}

export default App;
